import wx from 'weixin-js-sdk'

/**
 * 初始化微信分享所需的配置项
 * @param signObj:服务器端返回的签名配置项
 *          appId、timestamp、nonceStr、signature
 * @param isDebug:是否开启分享调试功能,true:开启,false:不开启
 */
export function initWXConfig(signObj, isDebug) {
  wx.config({
    debug: isDebug,
    appId: signObj.appId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
    timestamp: signObj.timestamp, // 必填，生成签名的时间戳
    nonceStr: signObj.nonceStr, // 必填，生成签名的随机串
    signature: signObj.signature.toLowerCase(), // 必填，签名，见附录1
    // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
    jsApiList: [
      'onMenuShareAppMessage', 'onMenuShareTimeline',
      'onMenuShareQQ', 'onMenuShareQZone', 'hideMenuItems'
    ]
  })
}

/**
 * 分享到微信、朋友圈、QQ、微博等平台
 * @param shareParams(title、link、image、abstract)
 */
export function shareWeChat(shareParams) {
  wx.ready(function() {
    wx.onMenuShareTimeline({
      title: shareParams.title, // 分享标题
      link: shareParams.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareParams.image, // 分享图标
      success: function(res) {
        console.log(res)
      },
      cancel: function(res) {
        console.log(res)
      }
    })
    // 分享给微信朋友
    wx.onMenuShareAppMessage({
      title: shareParams.title, // 分享标题
      desc: shareParams.abstract, // 分享描述
      link: shareParams.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareParams.image, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function(res) {
        console.log(res)
      },
      cancel: function(res) {
        console.log(res)
      }
    })
    // 分享到QQ
    wx.onMenuShareQQ({
      title: shareParams.title, // 分享标题
      desc: shareParams.abstract, // 分享描述
      link: shareParams.link, // 分享链接
      imgUrl: shareParams.image, // 分享图标
      success: function(res) {
        console.log(res)
        // 用户确认分享后执行的回调函数
        // logUtil.printLog('分享到QQ好友成功返回的信息为:', res)
      },
      cancel: function(res) {
        console.log(res)
        // 用户取消分享后执行的回调函数
        // logUtil.printLog('取消分享给QQ好友返回的信息为:', res)
      }
    })

    // 分享到QQ空间
    wx.onMenuShareQZone({
      title: shareParams.title, // 分享标题
      desc: shareParams.abstract, // 分享描述
      link: shareParams.link, // 分享链接
      imgUrl: shareParams.image, // 分享图标
      success: function(res) {
        console.log(res)
        // recordShareAction(shareParams.link)
      },
      cancel: function(res) {
        console.log(res)
      }
    })
    // if (wx.miniProgram) {
    //   wx.miniProgram.postMessage({ data: { title: shareParams.title }})
    // }
  })
}
